<template>
    <div id="unrevealed"></div>
</template>

<script>
    export default {
    };
</script>

<style scoped lang="scss">
    #unrevealed {
        height: 40px;
        width: 40px;

        background-color: gray;

        cursor: pointer;
    }
</style>